// src/stone/illustrations/StonjiPillarIntegrationsIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPillarIntegrationsIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 6.108,
          y: 11.8,
          fill: "#00A868",
          rx: 2,
          transform: "rotate(11.655 6.108 11.8)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M6.802 15.43a2 2 0 0 1 2.903-.875l5.265 3.355-.752 3.642a2 2 0 0 1-2.362 1.555l-5.32-1.097a2 2 0 0 1-1.424-2.77z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 3.868,
          y: 11.338,
          fill: "#00D483",
          rx: 2,
          transform: "rotate(11.655 3.868 11.338)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m13.115 15.581 2.086 1.209-.077.373-2.086-1.209zM12.96 16.328l2.086 1.21-.077.372-2.086-1.209z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 8.335,
          y: 0.461,
          fill: "#00A868",
          rx: 2,
          transform: "rotate(11.655 8.335 .46)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M9.027 4.092a2 2 0 0 1 2.903-.875l5.265 3.355-.751 3.642a2 2 0 0 1-2.363 1.555l-5.32-1.097a2 2 0 0 1-1.424-2.77z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 6.094,
          y: -1e-3,
          fill: "#00D483",
          rx: 2,
          transform: "rotate(11.655 6.094 -.001)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m15.34 4.242 2.087 1.21-.077.373-2.087-1.21zM15.186 4.99l2.087 1.208-.077.374-2.087-1.21z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 20.425,
          y: 8.722,
          fill: "#00A868",
          rx: 2,
          transform: "rotate(11.655 20.425 8.722)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M21.118 12.353a2 2 0 0 1 2.903-.876l5.265 3.356-.751 3.642a2 2 0 0 1-2.363 1.555l-5.32-1.097a2 2 0 0 1-1.424-2.77z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 18.185,
          y: 8.26,
          fill: "#00D483",
          rx: 2,
          transform: "rotate(11.655 18.185 8.26)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m27.431 12.503 2.087 1.209-.077.373-2.087-1.209zM27.277 13.25l2.086 1.209-.076.373-2.087-1.209z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 18.225,
          y: 20.288,
          fill: "#00A868",
          rx: 2,
          transform: "rotate(11.655 18.225 20.288)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M18.918 23.92a2 2 0 0 1 2.903-.876l5.265 3.355-.752 3.643a2 2 0 0 1-2.363 1.554l-5.32-1.097a2 2 0 0 1-1.423-2.77z"
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 9.913,
          height: 9.913,
          x: 15.984,
          y: 19.826,
          fill: "#00D483",
          rx: 2,
          transform: "rotate(11.655 15.984 19.826)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m25.23 24.07 2.087 1.208-.077.374-2.086-1.21zM25.077 24.816l2.086 1.21-.077.373L25 25.189z"
        }
      )
    ]
  }
);
var StonjiPillarIntegrationsIllustration_default = StonjiPillarIntegrationsIllustration;

export {
  StonjiPillarIntegrationsIllustration,
  StonjiPillarIntegrationsIllustration_default
};
